module.exports = __webpack_public_path__ + "img/公众号-3hvip.fbd66399.jpg";